<template>
  <FormLabel :mode="mode" :text="text" :required="required" :error="(!disabled && errorshowed) ? (forceError || error) : ''">
    <input class="aoformfield" :tabindex="disabled?(-1):null" :placeholder="placeholder" ref="input" :readonly="disabled || $store.getters.loading" :class="{ 'aoformfield_alignright': alignRight }" type="text" :name="name" v-maska :maxlength="maxlength" :data-maska="mask" :data-maska-tokens="tokens" @blur="filledCheck" autocomplete="off" @keydown.down.stop.prevent="$refs.droplist.focus()" v-model="val">
    <DropList v-if="trueoptions && !disabled" :options="trueoptions" :search="val" v-model="val" ref="droplist" @input="dropinput" />
    <slot />
  </FormLabel>
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import DropList from '@/components/DropList.vue'
import FormField from '@/mixins/FormField.vue'
import blur from '@/mixins/blur'
import { vMaska } from 'maska'
export default {
  components: { FormLabel, DropList },
  mixins: [FormField, blur],
  directives: { maska: vMaska },
  props: {
    required: { type: Boolean, default: false },
    mask: { type: String },
    tokens: { type: String, default: null },
    maxlength: { default: null },
    name: { type: String, required: true },
    modelValue: { type: String, default: '' },
    alignRight: { type: Boolean, default: false },
    text: { type: String, required: true },
    options: { type: Array },
    optionsFunction: { type: Function },
    disabled: { type: Boolean, default: false },
    selectonly: { type: Boolean, default: false },
    placeholder: { type: String },
    blurcondition: undefined,
    hideErrorWhenEmpty: { type: Boolean, default: false },
    validation: { type: Function, default: () => '' },
    forceError: { type: String, default: '' },
    filled: { type: Function, default: (v) => v ? true : false },
    mode: { type: Number, default: 0 }
  },
  data: () => ({
    fnoptions: undefined,
    lastindex: 0,
    error: '',
    selected: ''
  }),
  computed: {
    errorshowed(){
      if (this.hideErrorWhenEmpty && !this.modelValue)
        return false
      return true
    },
    val: {
      get() { return this.modelValue },
      set(value) { this.$emit('update:modelValue', value) },
    },
    trueoptions() {
      if (this.options)
        return this.options
      if (this.optionsFunction)
        return this.fnoptions
      return null
    }
  },
  mounted() {
    if (this.modelValue) {
      if (this.optionsFunction)
        this.updateOptions()
    }
  },
  watch: {
    modelValue(newVal) {
      this.checkValue(newVal)
      if (this.optionsFunction)
        this.updateOptions()
      //if (newVal && !this.error) 
      //this.$store.dispatch('callAction', this.name)
    },
    trueoptions: {
      handler() {
        this.checkValue(this.modelValue)
      },
      deep: true
    },
    optionsFunction: {
      handler(fn) {
        this.updateOptions(fn)
      },
      immediate: true
    }
  },
  methods: {
    async updateOptions(fn = this.optionsFunction) {
      if (!fn) return
      if (this.modelValue) {
        const index = ++this.lastindex
        let res = await fn(this.modelValue)
        if (index === this.lastindex)
          this.fnoptions = res
      }
      else
        this.fnoptions = []
    },
    dropinput(val) {
      if (this.blurcondition === undefined) {
        return this.blur()
      }
      else
        this.$nextTick(() => this.blurcondition ? this.blur() : this.$refs.input.focus())
      this.selected = val
    },
    checkValue(value) {
      this.error = ((this.selectonly && !this.trueoptions?.includes(value)) ? 'Выберите значение из списка' : '') || this.validation(value) || ''
      if (!this.error)
        this.filledCheck()
    },
    filledCheck() {
      if (this.modelValue == '') return this.error = ""
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
      }
    }
  }
}
</script>

<style lang="sass">

</style>